import React from 'react';
import { ChevronRight } from 'lucide-react';

const SettingItem = ({ label, icon: Icon, onClick, showArrow = true }) => (
  <button 
    onClick={onClick}
    className="flex items-center justify-between w-full py-3 border-b border-gray-100 last:border-0 hover:bg-gray-50 px-2 rounded-md transition-colors"
  >
    <div className="flex items-center space-x-3">
      {Icon && <Icon className="w-5 h-5 text-gray-600" />}
      <span className="text-gray-900">{label}</span>
    </div>
    {showArrow && <ChevronRight className="w-4 h-4 text-gray-400" />}
  </button>
);

export default SettingItem;